import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Icon } from '../icon/icon';
import { IconVariant } from '../icon/icon-data';
import { Typography } from '../typography/typography';
import styles from './inline-notification.module.scss';

type NotificationType = 'warning' | 'error' | 'success' | 'info';

type Props = {
  text?: string;
  title: string;
  type?: NotificationType;
  actions?: ReactNode;
};

const mapTypeToIcon: Record<NotificationType, IconVariant> = {
  warning: 'triangle-exclamation-mark',
  error: 'circle-cross',
  success: 'circle-check',
  info: 'circle-i',
};

export const InlineNotification: React.FC<Props> = ({ type = 'warning', title, text, actions }) => {
  return (
    <div
      className={classNames(styles.root, {
        [styles.isError]: type === 'error',
        [styles.isSuccess]: type === 'success',
        [styles.isInfo]: type === 'info',
      })}
    >
      <div className={styles.flag}>
        <Icon size="24" variant={mapTypeToIcon[type]} />
      </div>
      <div className={styles.content}>
        <Typography variant="headline-3">{title}</Typography>
        {text ? <Typography variant="maintext">{text}</Typography> : null}
        {actions ? <div className={styles.actionContainer}>{actions}</div> : null}
      </div>
    </div>
  );
};
